import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import lists from './modules/lists'
import common from './modules/common'
import market from './modules/market'
import translation from './modules/translation'
import recognitionControls from './modules/recognitionControls'
import pauses from './modules/pauses'

Vue.use(Vuex)

export default function createStore (API) {
  const store = new Vuex.Store({
    modules: {
      user: user(API),
      lists: lists(API),
      common: common(API),
      market: market(API),
      // trader: trader(API),
      recognitionControls: recognitionControls(API),
      pauses: pauses(API),
      translation: translation(API)
    },
    strict: Boolean(process.env.IS_DEV)
  })

  window.$store = store

  if (module.hot) {
    module.hot.accept(
      [
        './modules/user',
        './modules/lists',
        './modules/common',
        './modules/market',
        './modules/recognitionControls',
        './modules/pauses',
        './modules/translation'
      ],
      () => {
        store.hotUpdate({
          modules: {
            user: require('./modules/user').default(API),
            lists: require('./modules/lists').default(API),
            common: require('./modules/common').default(API),
            market: require('./modules/market').default(API),
            recognitionControls: require('./modules/recognitionControls').default(API),
            pauses: require('./modules/pauses').default(API),
            translation: require('./modules/translation').default(API)
          }
        })
      }
    )
  }

  return store
}
